'use strict';

import React, { Component } from 'react';
import Notif from '../../../../commonModules/interface/Notif';
import { isEmpty } from "lodash";
import Dialog from '../../../../commonModules/interface/Dialog';
import Form from 'react-jsonschema-form';
import Spin from '../../../../commonModules/interface/Spin';
import SuiviReports from '../../PaygPopUp/SuiviReports';
import { Table, TableBody, TableRow, TableCell, Button, TableHead, IconButton, Box } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import { TextArea, InputSelectNative } from '../../../../commonModules/interface/form-input-inline';
import { TableLayout } from '../../Stock/containers/Layout';


class Report extends Component {
    state = {
        commentF: false,
        actions: [],
        description: [],
        status: 'En attente',
        mood: "",
        comment: "",
        moodErr: "",
        commentErr: "",
        nature:"",
        
        validated: false,
        notifShow: false,
        notifTitle: "",
        notifMessage: "",
        validated:false,
        id: null,

        openBat:false,
        openPanel:false,
        openEquip:false,
        openBox:false,
        newReport1:false,
        newReport2:false,
        newReport3:false,
        reportList:null,
        forms:{
            tech: {
                jsonSchema:{
                    properties:{}
                },
                uiSchema:{}
            },
            com: {
                jsonSchema:{
                    properties:{}
                },
                uiSchema:{}
            },
        },
        formsList:[],
        formData:{},
        loading:false,
        details: false,
        reportComments:[]
    };
    componentWillMount() {
        this.getReports()
    }
    componentWillUnmount() {
        if (this.state.id) {
            clearTimeout(this.state.id);
        }
    }
    getReports = async ()=> {
        // fetch list of maintenance for this user
        try {
            let boxList = []
            const boxReportList = await fetch('/maintenance/boxReportList', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body: JSON.stringify({
                    // paygoID: boxIdList.content.info[i][1],
                    paygoID: this.props.boxAssoId,
                    boxAssoId: this.props.boxAssoId,
                    nbMax: 50,
                    from: 0,
                }),
                credentials: 'same-origin',
            });
            const boxReports = await boxReportList.json();
            console.log("showNew", boxReports);
            
            if (boxReports.maintenanceList) {
                const reportInfoList = await fetch('/maintenance/reportList', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                    },
                    body: JSON.stringify({
                        reportIdList: boxReports.maintenanceList
                    }),
                    credentials: 'same-origin',
                });
                let reportInfo = await reportInfoList.json();
                console.log('REPORT INFO  ', reportInfo);
                boxList = reportInfo.infoList;
                console.log('boxList array : ', boxList);
                this.setState({
                    reportList : boxList,
                    loading:false,
                })
            }
        } catch(err) {
            console.log(err);
        }
    }
    setActions = e => {
        let value = e.target.value;
        let name = e.target.name;
        console.log('LABEL : ', value);
        const tmpActions = this.state[name];
        const idx = tmpActions.indexOf(value);
        console.log('BEFORE ADD/DELETE : ', tmpActions);
        if (idx !== -1) {
            tmpActions.splice(idx, 1);
        } else {
            tmpActions.push(value);
        }
        console.log('AFTER ADD/DELETE : ', tmpActions);
        this.setState({ [name]: tmpActions });
    }
    setPriority = e => {
        this.setState({ priority: e.target.value })
    }
    handleSubmit1=({formData}) => {
        if (formData) {
            this.setState({
                formData:formData,
                newReport1:false,
                newReport2:true,
            })
        } else if( this.state.comment ){
            this.setState({
                newReport1:false,
                newReport2:true,
                commentErr : ''
            })
        } else {
            this.setState({
                commentErr : 'Veuillez remplir ce champ'
            })

        }
    }
    handleSubmit2=()=>{
        
        let errors = false
        let { mood, comment } = this.state
        console.log("submit 2", mood, comment);

        if (!mood){
            errors = true
            this.setState({ moodErr : "Veuillez remplir ce champ" })
        } else {
            this.setState({ moodErr : ""})
        }

        if (!comment){
            errors = true
            this.setState({ commentErr :'Veuillez remplir ce champ' })
        } else {
            this.setState({ commentErr :"" })
        }

        if( !errors ){
            this.setState({
                newReport2:false,
                newReport3:true,
            })
        }
            
    }
    submitForm = async () => {
        this.setState({loading:true})
        try {
            const { nature, mood, comment, formData } = this.state;
            console.log('SENDING REPORT');
            
            let content = {
                boxAssoId: this.props.boxAssoId,
                nature,
                // formData: this.state.formData,
                mood,
                comment,
                label: this.state.status,
            }
            nature !== "Other" ? content.formData = formData : content.formData = null;

            if ((comment || formData) && nature && mood) {
                console.log(this.props.boxId);
                const response = await fetch('/maintenance/sendReport', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                    },
                    body: JSON.stringify(content),
                    credentials: 'same-origin'
                });
                
                const body = await response.json();
                console.log(body);
                
                if (body.errorCode === 200) {
                    this.setState({
                        
                        validated: true,
                        notifShow: true,
                        notifType: 'success',
                        notifMessage: 'La panne a été créée.',
                        validated: true,
                        status: 'En attente',
                        mood: '',
                        comment: '',
                        newReport1:false,
                        newReport2:false,
                        newReport3:false,
                        loading:false
                    });
                    const checkboxes = document.getElementsByClassName('checkboxToReset');
                    for (let i = 0; i < checkboxes.length; ++i) {
                        checkboxes[i].checked = false;
                    }
                    // const id = setTimeout(() => this.setState({ notifType: 'success' }), 5000);
                    // this.setState({ id: id });
                    this.getReports()
                } else {
                    this.setState({
                        notifType: 'danger',
                        notifMessage: body.content,
                        notifShow: true ,
                        validated: true ,
                        loading:false
                    });
                    // const id = setTimeout(() => this.setState({ notifType: 'danger' }), 5000);
                    // this.setState({ id: id, loading:false });
                }
            }
        } catch (err) {
            console.log(err);
            this.setState({ loading:false });
        }
    }
    getSchema = async (id) => {
        if(id !== "Other"){
            id = id.toLowerCase()
            if(this.state.formsList.indexOf(id) === -1){
                try {
                    const infos = await fetch('/schema/getReportSchema',{
                        method:'POST',
                        headers: { 
                            'Content-Type': 'application/json',
                            //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                        },
                        body:JSON.stringify({
                            "idSchema":id
                        }),
                        credentials: 'same-origin',
                    });
                    let body = await infos.json();                

                    this.setState({
                        ...this.state,
                        forms:{
                            ...this.state.forms,
                            [id]:{
                                uiSchema: this.jsonValidation(body.uiSchema),
                                jsonSchema: this.jsonValidation(body.jsonSchema),
                            },
                            },
                            formsList:[
                                ...this.state.formsList,
                                id
                            ]
                    })
                        
                    console.log("[STATE] get Schema REPORT", this.state);      
        
                } catch (error) {
                    console.log("[ERROR] get Schema report",error)
                    return
                }
            } 
        }
        
        this.setState({
            loading:false
        })
        return      
    }
    jsonValidation(info) {
        let schemaTmp = info;
        try{
            schemaTmp = JSON.parse(info);
        }catch(e){
            console.log("[DEBUG],jsonValidation, Error ", e, " , parsing info ",info);
        }
        return schemaTmp
    }
    render() {
        console.log("[STATE STATE]", this.state);
        console.log("[PROPS PROPS]", this.props);
        const { reportList, details, reportComments, } = this.state;
        
        const formReport = (
            <Box p={1}>
                <InputSelectNative 
                    onChange={(e) => {
                        this.setState({
                            loading:true, 
                            nature: e.target.value, 
                            formData:{}, 
                            comment:"" 
                        }); 
                        this.getSchema(e.target.value)
                    }}
                    value={this.state.nature}
                    options={[
                        <option value="Tech">Problème Technique</option>,
                        <option value="Com">Problème Commercial</option>,
                        <option value="Other">Autre</option>
                    ]}
                    label="Nature du Problème"
                    required
                />
                
                {(this.state.nature === "Tech" && !this.state.loading) &&
                    <Form
                        schema={this.state.forms.tech.jsonSchema}
                        uiSchema={this.state.forms.tech.uiSchema}
                        formData={this.state.formData}
                        onSubmit={this.handleSubmit1}
                    >
                        <Button 
                            type="submit" 
                            color="secondary"
                            variant="contained"
                        >
                            Suivant
                        </Button>
                    </Form>
                }
                {(this.state.nature === "Com" && !this.state.loading) &&
                    <Form
                        schema={this.state.forms.com.jsonSchema}
                        uiSchema={this.state.forms.com.uiSchema}
                        formData={this.state.formData}
                        onSubmit={this.handleSubmit1}
                    >
                        <Button 
                            type="submit" 
                            color="secondary"
                            variant="contained"
                        >
                            Suivant
                        </Button>
                    </Form>
                }
                {this.state.nature === "Other" &&
                    <Box>
                        <TextArea 
                            label="Description du problème"
                            required
                            onChange={(e) => this.setState({ comment: e.target.value })}
                            value={this.state.comment}
                            error={this.state.commentErr}
                        />
                        <Button 
                            type="submit" 
                            onClick={this.handleSubmit1} 
                            color="secondary"
                            variant="contained"
                        >
                            Suivant
                        </Button>
                    </Box>
                }

            </Box>
            
        )
        const formReport2= (
            <Box p={1}>
                <InputSelectNative 
                    onChange={(e) => this.setState({ mood: e.target.value })}
                    value={this.state.mood}
                    options={[
                        <option>Heureux</option>,
                        <option>Normal</option>,
                        <option>Inquiet</option>,
                        <option>Triste</option>,
                        <option>En colère</option>
                    ]}
                    label="Etat du client"
                    required
                    error={this.state.moodErr}  // this.state.moodClass === 'form-group has-error'
                />
                {this.state.nature !== "Other" &&
                    <TextArea 
                        label="Description du problème"
                        required
                        onChange={(e) => this.setState({ comment: e.target.value })}
                        value={this.state.comment}
                        error={this.state.commentErr}
                    />
                }
                <Button
                    onClick={()=>this.setState({
                        newReport1:true,
                        newReport2:false,
                    })}
                    className="btn waves-effect"
                >
                    précedent
                </Button>
                <Button
                    onClick={this.handleSubmit2}
                    color="secondary"
                    variant="contained"
                >
                    Valider
                </Button>

                    
            </Box>
        )
        const formReport3= (
            <div>
                <h4> Résumé:   </h4>
                <TableLayout className="table">
                    <TableBody>

                        {this.state.formData && Object.keys(this.state.formData).map((question)=>
                            (<TableRow>
                                <TableCell>{question}</TableCell>
                                <TableCell>{this.state.formData[question]}</TableCell>
                            </TableRow>)
                        )}
                        {this.state.comment && 
                            <TableRow>
                                <TableCell>Description</TableCell>
                                <TableCell>{this.state.comment}</TableCell>
                            </TableRow>
                        }
                        <TableRow>
                            <TableCell>Etat du Client</TableCell>
                            <TableCell>{this.state.mood}</TableCell>
                        </TableRow>
                    </TableBody>
                </TableLayout>
                <Button
                    onClick={()=>this.setState({
                        // formData:formData,
                        newReport2:true,
                        newReport3:false,
                    })}
                    color="secondary"
                >
                    précedent
                </Button>
                <Button
                    onClick={()=>{
                        this.setState({
                            loading:true
                        });
                        this.submitForm()}}
                    color="secondary"
                    variant="contained"
                >
                    Valider
                </Button>

                
                {/* { this.state.validated && 
                    SAME IN RENDER
                    <div
                        data-growl="container"
                        className={this.state.notifClass}
                        role="alert" data-growl-position="top-right"
                        style={{position: 'fixed', margin: '0px', zIndex: 1031, display: 'inline-block', top: '85px', right: '20px'}}
                    >
                        
                        <span data-growl="icon"></span>
                        <span data-growl="title"> {this.state.notifTitle} </span><span data-growl="message">{this.state.notifMessage}</span><a href="#" data-growl="url"></a>
                    </div>
                } */}
            </div>
        )
        return (
            <div className="pmb-block">
                {this.state.newReport1 &&    
                <Dialog
                    title="Créer une Panne"
                    block={true}
                    text={formReport}
                    close={()=>this.setState({newReport1:false, nature:"", formData:{} })}
                />
                }
                {this.state.newReport2 &&    
                <Dialog
                    title="Créer une Panne"
                    block={true}
                    text={formReport2}
                    close={()=>this.setState({newReport2:false, nature:"", formData:{} })}
                />
                }
                {this.state.newReport3 &&    
                <Dialog
                    title="Créer une Panne"
                    block={true}
                    text={formReport3}
                    close={()=>this.setState({newReport3:false, nature:"", formData:{} })}
                />
                }
                {this.state.loading && <Spin /> }

                <div className="row m-5 text-right">
                    {details &&
                        <IconButton
                            onClick={() => this.setState({  details: false, reportComments:[]  }) }
                            color="secondary"
                        >
                            <ArrowBack />
                        </IconButton>
                    }
                    <Button 
                        onClick={() => this.setState({ newReport1:true }) }
                        color="secondary"
                    >
                        Creer une Panne
                    </Button>
                </div>
                {!reportList && <Spin noOverlay={true}/>}

                {details && !isEmpty(reportComments) &&
                    <SuiviReports 
                        comments={this.state.reportComments}
                        paygoID={this.props.paygoAssoId}
                        closeDetails={() => this.setState({ details: false, reportComments:[] })}
                    />
                }
                
                {reportList && !details &&
                    <TableLayout>
                        <TableHead>
                            <TableRow>
                                <TableCell>Dernière MAJ</TableCell>
                                <TableCell>Humeur</TableCell>
                                {/* <TableCell>Actions à effectuer</TableCell> */}
                                <TableCell>Statut</TableCell>
                                <TableCell>Dernier Commentaire</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {reportList.map( report => (

                                <TableRow 
                                    hover
                                    onClick={ () => this.setState({ 
                                        details: true, 
                                        reportComments: report.comments 
                                    })}
                                >
                                    <TableCell>{(new Date(report.timeUpdate)).toLocaleString('fr-FR')}</TableCell>
                                    <TableCell>{report.Mood[0].val}</TableCell>
                                    {/* <TableCell>{report.actions[0].val.toString()}</TableCell> */}
                                    <TableCell>{report.labels[(report.labels.length)-1].val}</TableCell>
                                    <TableCell>{report.comments[(report.comments.length)-1].comment}</TableCell>
                                </TableRow>
                            ) 
                            )}
                        </TableBody>
                    </TableLayout>
                }
                {/* TODO UPDATE NOTIF */}
                {this.state.validated && this.state.notifShow &&
                <Notif 
                    show={this.state.notifShow}
                    close={() => this.setState({ notifShow: false }) }
                    message={this.state.notifMessage}
                    type={this.state.notifType}
                />
                // <div
                //     data-growl="container"
                //     className={this.state.notifClass}
                //     role="alert" data-growl-position="top-right"
                //     style={{position: 'fixed', margin: '0px', zIndex: 15000, display: 'inline-block', top: '85px', right: '20px'}}
                // >
                    
                //     <span data-growl="icon"></span>
                //     <span data-growl="title"> {this.state.notifTitle} </span><span data-growl="message">{this.state.notifMessage}</span><a href="#" data-growl="url"></a>
                // </div>
                }
            </div>
        );
    }
}
export default Report
